import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

const faqData: FAQItem[] = [
  {
    question: '国产手机自拍效果真的能比得上苹果、三星吗？',
    answer: '完全可以。近年来国产手机在影像领域进步巨大，华为、vivo、OPPO等品牌的前置摄像头硬件素质和AI美颜算法已经达到甚至超越了国际品牌。而且国产手机更懂亚洲用户的审美偏好，人像美化效果更加自然符合国人审美。关键还是在于掌握正确的自拍技巧——这也是我们整个网站的核心教学内容。',
  },
  {
    question: '我是完全零基础的小白，从哪里开始学起最合适？',
    answer: '建议从"构图技巧"板块开始学习。三分法是最基础也最容易见效的构图法则，只要打开手机相机的网格线功能，5分钟就能学会。掌握基础构图后，再逐步学习光线运用和后期修图。我们的每篇教程都由浅入深，即使完全零基础也能跟得上。',
  },
  {
    question: '需要购买专业的灯光设备吗？',
    answer: '不需要。对于绝大多数日常自拍场景，自然光就是最好的光源。学习利用窗口光、黄金时刻的柔和阳光，比任何补光灯都更自然好看。如果你有夜间自拍需求，可以考虑入手一个几十元的环形补光灯，但完全不是必需品。我们的"自然光自拍秘籍"文章中有详细讲解如何纯靠自然光拍出高级感。',
  },
  {
    question: '修图会让照片失真吗？如何做到自然美颜？',
    answer: '好的修图是"看不出修过"的修图。关键原则是"少即是多"——先调整曝光和色温等全局参数，再针对局部瑕疵做精细修复，最后根据喜好微调色调。避免一键美颜的过度磨皮，保留皮肤的自然质感和细节。我们在后期修图板块有详细的App使用教程和自然美颜技巧。',
  },
  {
    question: '这个网站的内容是免费的吗？',
    answer: '是的，目前网站上的所有自拍教程和攻略内容都是完全免费的。我们致力于打造国内最专业的国产自拍教学平台，帮助更多人用手机拍出满意的自拍。未来可能会推出付费的高阶课程，但基础核心内容会始终保持免费开放。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-16 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            常见问题解答
          </h2>
          <p className="text-foreground-600 text-sm">
            关于国产自拍学习，你最关心的几个问题
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqData.map((faq, idx) => (
            <div
              key={idx}
              className="border border-background-200/70 rounded-xl overflow-hidden"
            >
              <button
                onClick={() => toggleFAQ(idx)}
                className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left hover:bg-background-100 transition-colors cursor-pointer"
              >
                <span className="font-medium text-foreground-900 text-sm">
                  {faq.question}
                </span>
                <i
                  className={`ri-arrow-down-s-line text-foreground-500 text-lg transition-transform flex-shrink-0 ${
                    openIndex === idx ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              {openIndex === idx && (
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* FAQPage structured data */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'FAQPage',
              mainEntity: faqData.map((faq) => ({
                '@type': 'Question',
                name: faq.question,
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: faq.answer,
                },
              })),
            }),
          }}
        />
      </div>
    </section>
  );
}